import "./CoreValues.css";
import {
  Globe,
  Users,
  ChartNoAxesColumnIncreasing,
  LockKeyhole,
} from "lucide-react";

const values = [
  {
    icon: Globe,
    title: "Absolute Transparency",
    description:
      "We build tools that make parameters, deliverables, contracts, and payout timelines visible to everyone instantly. Trust is constructed through open systems.",
  },
  {
    icon: Users,
    title: "Creator-First Respect",
    description:
      "Creators are primary partners. We minimize their friction with precise guidelines, secure automated licensing tools, and instant, painless payments.",
  },
  {
    icon: ChartNoAxesColumnIncreasing,
    title: "Data-Driven Science",
    description:
      "Decisions must map back to facts. We engineer deep analytics engines that tie brand awareness spikes to real consumer acquisition activities.",
  },
  {
    icon: LockKeyhole,
    title: "Relentless Simplicity",
    description:
      "Marketing stacks suffer from enterprise bloat. We obsess over clean interfaces, intuitive flows, and lightning-fast onboarding loops.",
  },
];

const CoreValues = () => {
  return (
    <section className="core-values">
      <div className="core-values__container">

        <div className="core-values__header">
          <h2>Our core values</h2>

          <p>
            These foundational principles drive our team's alignment, design
            aesthetics, and product goals.
          </p>
        </div>

        <div className="core-values__grid">
          {values.map((value) => {
            const Icon = value.icon;

            return (
              <article className="core-value-card" key={value.title}>
                <div className="core-value-card__icon">
                  <Icon size={21} strokeWidth={1.8} />
                </div>

                <h3>{value.title}</h3>

                <p>{value.description}</p>
              </article>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default CoreValues;